import React, {useCallback, useMemo} from 'react';

import {LATEST_DOCUMENT_VERSION} from 'notebook/documents/DocumentActions';
import documentStore from 'notebook/documents/DocumentStore';
import useDocument from 'notebook/documents/useDocument';
import {
  createNoteSelector,
  TableNoteContext,
  TableNoteContextInterface,
} from 'notebook/tables/store/contexts/TableNoteContext';

/**
 * Provides the TableNoteContext for documents.
 */
export function DocumentNoteProvider({
  documentId,
  tableNamespace,
  children,
}: {
  documentId: string;
  tableNamespace: string;
  children: React.ReactNode;
}): JSX.Element {
  const {updateNote} = useDocument(documentId, LATEST_DOCUMENT_VERSION, true);
  const getNote = useCallback(() => documentStore.getNote(documentId), [documentId]);
  const useNoteSelector = useMemo(() => createNoteSelector(documentStore, documentId), [documentId]);

  const contextValue: TableNoteContextInterface = useMemo(
    () => ({fileId: documentId, tableNamespace, getNote, updateNote, useNoteSelector}),
    [documentId, tableNamespace, getNote, updateNote, useNoteSelector]
  );

  return <TableNoteContext.Provider value={contextValue}>{children}</TableNoteContext.Provider>;
}
